import React, { useEffect, useState } from "react";
import theme from "../../theme";
import { useDispatch, useSelector } from "react-redux";
import { getAnalytics } from "../../redux/slices/overviewSlice";
import {
  BarChart,
  Bar,
  XAxis,
  CartesianGrid,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import styled from "styled-components";
import { useMediaQuery } from "@mui/material";

const Barchart = () => {
  const dispatch = useDispatch();
  const { analytics } = useSelector((state) => state.overview);

  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const years = [];
  for (let i = currentYear; i >= 2020; i--) {
    years.push(i);
  }

useEffect(() => {
  dispatch(getAnalytics({year}));
  },[dispatch, year]);
  //console.log(analytics)

  const handleYear = (event) => {
    const selectedYear = Number(event.target.value);
    setYear(selectedYear);
  };

  // Template for all months
  const monthsTemplate = [
    { name: "Jan", conversion: null, clicks: null },
    { name: "Feb", conversion: null, clicks: null },
    { name: "Mar", conversion: null, clicks: null },
    { name: "Apr", conversion: null, clicks: null },
    { name: "May", conversion: null, clicks: null },
    { name: "Jun", conversion: null, clicks: null },
    { name: "Jul", conversion: null, clicks: null },
    { name: "Aug", conversion: null, clicks: null },
    { name: "Sep", conversion: null, clicks: null },
    { name: "Oct", conversion: null, clicks: null },
    { name: "Nov", conversion: null, clicks: null },
    { name: "Dec", conversion: null, clicks: null },
  ];

  // Mapping fetched data to the template
  const data = monthsTemplate.map((month) => {
    const match = analytics.find((item) => item.month.slice(0, 3) === month.name);
    return match
      ? {
          name: month.name,
          conversion: match.totalConversions,
          clicks: match.totalClicks,
        }
      : month;
  });

  const formatCurrency = (tick) => {
    if (tick >= 1000000) return `${tick / 1000000}m`;
    if (tick >= 1000) return `${tick / 1000}k`;
    return tick;
  };

  const CustomConversionBar = (props) => {
    const { fill, x, y, height } = props;
    const radius = 3;
    const isTab = useMediaQuery("(max-width:867px)");
    const isMobile = useMediaQuery("(max-width:567px)");
    const barWidth = isMobile ? 15 : isTab ? 25 : 37;
    return (
      <rect
        x={x}
        y={y}
        width={barWidth}
        height={height}
        fill={fill}
        rx={radius}
        ry={radius}
      />
    );
  };

  const CustomClicksBar = (props) => {
    const { fill, x, y, height } = props;
    const radius = 3;
    const isTab = useMediaQuery("(max-width:867px)");
    const isMobile = useMediaQuery("(max-width:567px)");
    const barWidth = isMobile ? 15 : isTab ? 25 : 37;
    return (
      <rect
        x={x}
        y={y}
        width={barWidth}
        height={height}
        fill={fill}
        rx={radius}
        ry={radius}
      />
    );
  };

  return (
    <div style={{ marginLeft: "-30px", marginTop: "20px" }}>
      <Header>
        <div></div>
        <div>
        <select className="see-more2" value={year} onChange={handleYear}>
              <option value="" disabled>Select Year</option>
              {years.map((yearOption) => (
                <option key={yearOption} value={yearOption}>
                  {yearOption}
                </option>
              ))}
            </select>
        </div>
      </Header>
      <ResponsiveContainer width={"100%"} height={300}>
        <BarChart data={data}>
          <CartesianGrid vertical={false} stroke="#eee"strokeDasharray="3 3" />
          <YAxis
            stroke="#9C9C9C"
            fontSize={10}
            fontWeight={300}
            minTickGap={1}
            tickFormatter={formatCurrency}
            axisLine={false}
            tickLine={false}
            // label={{
            //   value: "Active users",
            //   angle: -90,
            //   position: "insideLeft",
            // }}
          />
          <XAxis
            dataKey="name"
            stroke="#9C9C9C"
            fontSize={10}
            fontWeight={300}
            minTickGap={1}
            axisLine={false}
            tickLine={false}
            // label={{ value: "Month", position: "insideBottom", offset: -5 }}
          />
          <Tooltip />
          <Legend verticalAlign="top" height={36} />
          <Bar
            type="monotone"
            dataKey="conversion"
            fill={theme.color.brand}
            stackId="a"
            shape={<CustomConversionBar />}
          />
          <Bar
            type="monotone"
            dataKey="clicks"
            fill={theme.chart[2]}
            stackId="a"
            shape={<CustomClicksBar />}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    .see-more2 {
      padding: 10px 16px;
      height: 42px;
      border: 2px solid #d0d5dd;
      border-radius: 10px;
      font-size: 14px;
      font-weight: 500;
      background-color: transparent;
      color: #344054;
      cursor: pointer;
      transition: all 0.3s ease;
      
      &:focus {
        outline: none;
        border-color: ${theme.color.brand};
        //box-shadow: 0 0 0 3px rgba(3, 169, 244, 0.1);
      }
      
      option {
        color: #344054;
      }
    }
  `;
export default Barchart;
